import { AfterViewInit, Component, Inject, NgModule, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { setTimeout$ } from '../../utils/setTimeout$';

declare global {
    interface Window {
        Trustpilot: any;
    }
}

@Component({
    selector: 'app-trustpilot-widget',
    templateUrl: './trustpilot-widget.component.html',
    styleUrls: ['./trustpilot-widget.component.scss']
})
export class TrustpilotWidgetComponent implements OnInit, AfterViewInit {
    isBrowser = false;

    constructor(
        @Inject(PLATFORM_ID) platformId: {},
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        setTimeout$(() => {
            const trustboxRef = document.getElementById('trustbox');
            if (window.Trustpilot) {
                window.Trustpilot.loadFromElement(trustboxRef);
            }
        }, 100);
    }

}

@NgModule({
    declarations: [TrustpilotWidgetComponent],
    imports: [
        CommonModule
    ],
    exports: [TrustpilotWidgetComponent]
})
export class TrustpilotWidgetModule {
}
